import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-usuario',
  templateUrl: './btn-nuevo-usuario.component.html',
  styleUrls: ['./btn-nuevo-usuario.component.css']
})
export class BtnNuevoUsuarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
